import type { Tender } from '~/models/tenders';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ListedData, StackItem } from 'Components/nui/Wizard';
import * as Data from 'Components/Data';
import { FixedPriceIcon } from './View/components';

type OrderDetailsProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  orders: any[];
  /**
   * Heading shown above the list. Defaults to the tender-aware
   * "Offers"/"Bids" label when `tender` is provided.
   */
  title?: React.ReactNode;
  tender?: Tender;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  titleSuffix?: (order: any) => React.ReactNode;
};

export const OrderDetails = ({
  tender,
  orders,
  title,
  titleSuffix,
}: OrderDetailsProps) =>
  orders.length ? (
    <ListedData
      title={
        title ??
        (tender && (
          <FormattedMessage
            id="tender-create-review-summary-field-orders"
            description="Field for Bids/Offers on review summary on tenders create/edit pages"
            defaultMessage="{orderType, select, offer {Offers} bid {Bids} other{{orderType}}}"
            values={{ orderType: tender.ordername.order }}
          />
        ))
      }
      className="summary-orders-list"
    >
      {orders.map((order) => (
        <StackItem
          key={order.id}
          title={
            <>
              {order.product.name}
              {order.state?.fixed_index && (
                <FixedPriceIcon className="icon-text-middle" />
              )}
              {titleSuffix?.(order)}
            </>
          }
          data={
            <>
              <Data.IndexUnit value={order.startprice} />{' '}
              {order.reserve?.price?.val && (
                <>
                  <FormattedMessage
                    id="tender-create-review-summary-field-reserve-price"
                    description="Field for Reserve price on review summary on tenders create/edit pages"
                    defaultMessage="Reserve price:"
                  />{' '}
                  <Data.Price value={order.reserve.price} />
                  {' | '}
                </>
              )}
              <Data.Price
                onZero={
                  <FormattedMessage
                    id="generic-any"
                    description="Text Any"
                    defaultMessage="Any"
                  />
                }
                value={order.startprice}
              />{' '}
              / <Data.Volume value={order.volume} /> {order.volume.unit}
              {order.attributes ? (
                <Data.Attributes value={order.attributes} />
              ) : (
                <br />
              )}
              <strong className="tw:font-medium">
                <FormattedMessage
                  id="tender-details-summary-field-etd"
                  description="Field for `ETD` in summary in tender details page"
                  defaultMessage="ETD"
                />
              </strong>{' '}
              <Data.ETD value={order.etd} />
              {order.productionmonth && (
                <>
                  <br />
                  <Data.ProductionMonth value={order.productionmonth.display} />
                </>
              )}
            </>
          }
        />
      ))}
    </ListedData>
  ) : null;

export default OrderDetails;
